(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["load-more"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('infinite-scroll')) {
    customElements.define(
      'infinite-scroll',
      class extends HTMLElement {
        connectedCallback() {
          this.grid = document.querySelector(this.dataset.grid);
          this.button = this.querySelector('.load-more__button');
          this.progress = this.querySelector('.load-more__progress');
          this.bar = this.querySelector('.load-more__bar');
          this.status = this.querySelector('.load-more__sr');
          this.nextUrl = this.dataset.nextUrl;
          this.loading = false;
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const current = new URL(location.href);
          this.stockFirst = this.hasAttribute('data-stock-first') && !current.searchParams.has('filter.v.availability');
          if (this.stockFirst) {
            current.searchParams.delete('page');
            current.searchParams.set('filter.v.availability', '1');
            this.nextUrl = current.href;
            current.searchParams.set('filter.v.availability', '0');
            this.soldOutUrl = current.href;
            this.stockPhase = 'available';
            this.replaceInitial = true;
            this.sectionId = this.closest('.shopify-section')?.id.replace('shopify-section-', '') || 'collection';
          } else if (this.hasAttribute('data-stock-first') && this.dataset.hasNext !== 'true') {
            this.nextUrl = '';
            this.button.hidden = true;
            this.classList.add('is-done');
          }
          if (!this.grid || !this.nextUrl || !('IntersectionObserver' in window)) return;
          this.button.addEventListener('click', (event) => {
            event.preventDefault();
            this.load();
          });
          this.button.hidden = true;
          this.observer = new IntersectionObserver(
            (entries) => {
              if (entries.some((entry) => entry.isIntersecting)) this.load();
            },
            { rootMargin: '900px 0px' }
          );
          if (this.stockFirst) this.load();
          else this.observer.observe(this);
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
          if (this.revealObserver) this.revealObserver.disconnect();
          cancelAnimationFrame(this.progressFrame);
          this.controller?.abort();
        }

        startProgress() {
          this.progressValue = 0;
          this.bar.classList.remove('is-finishing');
          this.bar.style.transform = 'scaleX(0)';
          this.progress.hidden = false;
          const tick = () => {
            this.progressValue += (90 - this.progressValue) * 0.06;
            this.bar.style.transform = `scaleX(${this.progressValue / 100})`;
            this.progressFrame = requestAnimationFrame(tick);
          };
          this.progressFrame = requestAnimationFrame(tick);
        }

        finishProgress() {
          cancelAnimationFrame(this.progressFrame);
          this.bar.classList.add('is-finishing');
          this.bar.style.transform = 'scaleX(1)';
          return new Promise((resolve) => {
            setTimeout(() => {
              this.progress.hidden = true;
              resolve();
            }, 350);
          });
        }

        cancelProgress() {
          cancelAnimationFrame(this.progressFrame);
          this.progress.hidden = true;
        }

        async load() {
          if (this.loading || !this.nextUrl) return;
          this.loading = true;
          this.button.hidden = true;
          this.startProgress();
          this.status.textContent = this.dataset.loadingText;
          this.controller = new AbortController();
          try {
            if (this.stockFirst) {
              await this.loadStockPage();
              await this.finishProgress();
              this.loading = false;
              if (this.nextUrl) {
                this.status.textContent = '';
                this.observer.unobserve(this);
                this.observer.observe(this);
              } else {
                this.observer.disconnect();
                this.status.textContent = this.dataset.loadedText;
                this.classList.add('is-done');
              }
              return;
            }
            const response = await fetch(this.nextUrl, { signal: this.controller.signal });
            if (!response.ok) throw new Error(`Load more failed: ${response.status}`);
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const finished = this.finishProgress();
            const nextGrid = doc.querySelector(this.dataset.grid);
            const items = nextGrid ? Array.from(nextGrid.children) : [];
            this.grid.append(...items);
            this.reveal(items);
            if (this.dataset.grid === '.collection__grid') {
              [...this.grid.children].filter((card) => card.dataset.available === 'false')
                .forEach((card) => this.grid.append(card));
            }
            if (this.dataset.count) {
              const current = document.querySelector(this.dataset.count);
              const updated = doc.querySelector(this.dataset.count);
              if (current && updated) current.textContent = updated.textContent;
            }
            const next = doc.querySelector(`infinite-scroll[data-grid="${this.dataset.grid}"]`);
            this.nextUrl = (next && next.dataset.nextUrl) || '';
            await finished;
            this.loading = false;
            if (this.nextUrl) {
              this.status.textContent = '';
              this.observer.unobserve(this);
              this.observer.observe(this);
            } else {
              this.observer.disconnect();
              this.status.textContent = this.dataset.loadedText;
              this.classList.add('is-done');
            }
          } catch (error) {
            this.loading = false;
            this.cancelProgress();
            this.status.textContent = '';
            this.button.hidden = false;
          }
        }

        reveal(cards) {
          if (!cards.length || this.reducedMotion || !('IntersectionObserver' in window)) return;
          this.revealObserver ||= new IntersectionObserver(
            (entries) => {
              const visible = entries.filter((entry) => entry.isIntersecting).map((entry) => entry.target);
              visible.forEach((card, index) => {
                this.revealObserver.unobserve(card);
                const delay = Math.min(index * 70, 420);
                this.whenImageReady(card).then(() => {
                  card.style.setProperty('--enter-delay', `${delay}ms`);
                  card.classList.add('is-revealed');
                });
              });
            },
            { rootMargin: '0px 0px -6% 0px' }
          );
          cards.forEach((card) => {
            card.classList.add('load-more-enter');
            card.addEventListener('animationend', (event) => {
              if (event.target !== card) return;
              card.classList.remove('load-more-enter', 'is-revealed');
              card.style.removeProperty('--enter-delay');
            });
            this.revealObserver.observe(card);
          });
        }

        whenImageReady(card) {
          const image = card.querySelector('img');
          if (!image) return Promise.resolve();
          if (image.loading === 'lazy') image.loading = 'eager';
          const loaded = image.complete && image.naturalWidth
            ? Promise.resolve()
            : new Promise((resolve) => {
                image.addEventListener('load', resolve, { once: true });
                image.addEventListener('error', resolve, { once: true });
              });
          const decoded = loaded.then(() => image.decode?.()).catch(() => {});
          return Promise.race([decoded, new Promise((resolve) => setTimeout(resolve, 1200))]);
        }

        reorder(cards) {
          const existing = new Map([...this.grid.children].map((card) => [card.dataset.productId, card]));
          const nodes = cards.map((card) => existing.get(card.dataset.productId) || card);
          const unchanged = nodes.length === this.grid.children.length &&
            nodes.every((node, index) => node === this.grid.children[index]);
          if (unchanged) return;
          const kept = nodes.filter((node) => node.parentElement === this.grid);
          const before = new Map(kept.map((node) => [node, node.getBoundingClientRect()]));
          this.grid.replaceChildren(...nodes);
          this.reveal(nodes.filter((node) => !before.has(node)));
          if (this.reducedMotion) return;
          const viewport = window.innerHeight;
          kept.forEach((node) => {
            const from = before.get(node);
            const to = node.getBoundingClientRect();
            const dx = from.left - to.left;
            const dy = from.top - to.top;
            if (!dx && !dy) return;
            const onScreen = (rect) => rect.bottom > 0 && rect.top < viewport;
            if (!onScreen(from) && !onScreen(to)) return;
            node.animate(
              [{ transform: `translate(${dx}px, ${dy}px)` }, { transform: 'translate(0, 0)' }],
              { duration: 550, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
            );
          });
        }

        async loadStockPage() {
          this.grid.setAttribute('aria-busy', 'true');
          try {
            let cards = [];
            const visited = new Set();
            while (this.nextUrl && !cards.length) {
              if (visited.has(this.nextUrl)) throw new Error('Repeated collection page');
              visited.add(this.nextUrl);
              const phase = this.stockPhase;
              const result = await window.ditchStock.page(this.nextUrl, this.sectionId, this.controller.signal);
              cards = result.cards.filter((card) => card.dataset.available === (phase === 'available' ? 'true' : 'false'));
              this.nextUrl = result.next;
              if (!this.nextUrl && phase === 'available') {
                this.stockPhase = 'sold-out';
                this.nextUrl = this.soldOutUrl;
              }
            }
            if (this.replaceInitial) {
              this.replaceInitial = false;
              this.reorder(cards);
            } else {
              const ids = new Set([...this.grid.children].map((card) => card.dataset.productId));
              const added = cards.filter((card) => !ids.has(card.dataset.productId));
              this.grid.append(...added);
              this.reveal(added);
            }
            const count = document.querySelector(this.dataset.count);
            if (count) count.textContent = this.dataset.countTemplate
              .replace('[shown]', this.grid.children.length).replace('[total]', this.dataset.totalCount);
          } finally {
            this.grid.removeAttribute('aria-busy');
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["notify-restock"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('notify-restock')) {
    customElements.define(
      'notify-restock',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('.notify');
          this.form = this.querySelector('.notify__form');
          this.input = this.querySelector('.notify__input');
          this.submit = this.querySelector('.notify__submit');
          this.message = this.querySelector('[data-notify-message]');
          this.item = this.querySelector('[data-notify-item]');
          if (!this.dialog) return;
          document.addEventListener('click', (event) => {
            const trigger = event.target.closest('[data-notify-variant]');
            if (!trigger) return;
            event.preventDefault();
            this.variant = trigger.dataset.notifyVariant;
            this.item.textContent = trigger.dataset.notifyLabel || '';
            this.message.textContent = '';
            this.form.reset();
            this.dialog.showModal();
            this.input.focus();
          });
          this.querySelectorAll('[data-notify-close]').forEach((button) => {
            button.addEventListener('click', () => this.dialog.close());
          });
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });
          this.form.addEventListener('submit', (event) => {
            event.preventDefault();
            this.subscribe();
          });
        }
        async subscribe() {
          this.submit.disabled = true;
          this.message.textContent = '';
          try {
            const response = await fetch(
              `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.dataset.key}`,
              {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', revision: '2024-06-15' },
                body: JSON.stringify({
                  data: {
                    type: 'back-in-stock-subscription',
                    attributes: {
                      profile: { data: { type: 'profile', attributes: { email: this.input.value } } },
                      channels: ['EMAIL'],
                    },
                    relationships: {
                      variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${this.variant}` } },
                    },
                  },
                }),
              }
            );
            if (!response.ok) throw new Error(response.status);
            this.message.textContent = this.dataset.success;
            this.form.reset();
          } catch (error) {
            this.message.textContent = this.dataset.error;
          } finally {
            this.submit.disabled = false;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["preorder-notice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mixed-order')) {
    customElements.define(
      'mixed-order',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('.mixed-order');
          const trigger = this.querySelector('[data-mixed-open]');
          if (!this.dialog || !trigger) return;
          trigger.addEventListener('click', () => this.dialog.showModal());
          this.querySelectorAll('[data-mixed-close]').forEach((button) => {
            button.addEventListener('click', () => this.dialog.close());
          });
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-add"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quick-add')) {
    customElements.define(
      'quick-add',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('.quick-add__dialog');
          const trigger = this.querySelector('[data-quick-add-open]');
          if (!this.dialog || !trigger) return;
          trigger.addEventListener('click', (event) => {
            event.preventDefault();
            this.dialog.showModal();
          });
          this.querySelectorAll('[data-quick-add-close]').forEach((button) => {
            button.addEventListener('click', () => this.dialog.close());
          });
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('search-drawer')) {
    customElements.define(
      'search-drawer',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('.search-drawer');
          this.input = this.querySelector('.search-drawer__input');
          this.results = this.querySelector('[data-search-results]');
          if (!this.dialog) return;
          this.initial = this.results.innerHTML;
          document.querySelectorAll('[data-search-open]').forEach((opener) => {
            opener.addEventListener('click', (event) => {
              event.preventDefault();
              this.dialog.showModal();
              this.input.focus();
            });
          });
          this.querySelectorAll('[data-search-close]').forEach((button) => {
            button.addEventListener('click', () => this.dialog.close());
          });
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });
          this.input.addEventListener('input', () => {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => this.search(), 250);
          });
        }
        async search() {
          const query = this.input.value.trim();
          if (this.controller) this.controller.abort();
          if (!query) {
            this.results.innerHTML = this.initial;
            return;
          }
          this.controller = new AbortController();
          try {
            const params = new URLSearchParams({
              q: query,
              section_id: 'predictive-search',
              'resources[type]': 'query,product,page',
              'resources[limit]': '4',
              'resources[limit_scope]': 'each',
              'resources[options][unavailable_products]': 'last',
            });
            const response = await fetch(`${this.dataset.url}?${params}`, { signal: this.controller.signal });
            const html = await response.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const section = doc.querySelector('.shopify-section') || doc.body;
            this.results.innerHTML = section.innerHTML;
          } catch (error) {
            if (error.name !== 'AbortError') throw error;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["spotify-player"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('spotify-player')) {
    customElements.define(
      'spotify-player',
      class extends HTMLElement {
        connectedCallback() {
          this.frame = this.querySelector('[data-player-frame]');
          if (!this.frame) return;

          this.onClick = (event) => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
            const tile = event.target.closest('[data-spotify]');
            if (!tile) return;
            const embed = this.embedUrl(tile.dataset.spotify);
            if (!embed) return;
            event.preventDefault();
            this.open(embed);
          };
          document.addEventListener('click', this.onClick);

          this.querySelector('[data-player-close]').addEventListener('click', () => this.close());

          this.onSectionLoad = () => this.hydrate();
          document.addEventListener('shopify:section:load', this.onSectionLoad);

          this.hydrate();
        }

        disconnectedCallback() {
          document.removeEventListener('click', this.onClick);
          document.removeEventListener('shopify:section:load', this.onSectionLoad);
        }

        embedUrl(raw) {
          if (!raw) return '';
          try {
            const url = new URL(raw);
            if (url.hostname !== 'open.spotify.com') return '';
            if (url.pathname.startsWith('/embed/')) return url.origin + url.pathname;
            return `${url.origin}/embed${url.pathname}`;
          } catch {
            return '';
          }
        }

        open(embed) {
          if (this.frame.src !== embed) this.frame.src = embed;
          this.hidden = false;
        }

        close() {
          this.hidden = true;
          this.frame.src = '';
        }

        async metadata(raw) {
          const key = `ditch:spotify:${raw}`;
          try {
            const cached = sessionStorage.getItem(key);
            if (cached) return JSON.parse(cached);
          } catch {}
          const response = await fetch(`https://open.spotify.com/oembed?url=${encodeURIComponent(raw)}`);
          if (!response.ok) throw new Error(`oEmbed ${response.status}`);
          const data = await response.json();
          try {
            sessionStorage.setItem(key, JSON.stringify(data));
          } catch {}
          return data;
        }

        hydrate() {
          document.querySelectorAll('[data-spotify]').forEach(async (tile) => {
            const raw = tile.dataset.spotify;
            if (!this.embedUrl(raw)) return;
            let data;
            try {
              data = await this.metadata(raw);
            } catch {
              return;
            }
            const name = tile.querySelector('[data-spotify-name]');
            if (name && data.title && !name.textContent.trim()) name.textContent = data.title;
            const art = tile.querySelector('[data-spotify-art]');
            if (art && data.thumbnail_url && !art.querySelector('img')) {
              const image = document.createElement('img');
              image.src = data.thumbnail_url;
              image.alt = '';
              image.loading = 'lazy';
              art.append(image);
            }
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
